import { forwardRef } from "react";
import { cn } from "@/lib/utils";
import { motion, type HTMLMotionProps } from "framer-motion";

interface KCardProps extends HTMLMotionProps<"div"> {
  hoverable?: boolean;
}

export const KCard = forwardRef<HTMLDivElement, KCardProps>(
  ({ className, hoverable = false, children, ...props }, ref) => {
    return (
      <motion.div
        ref={ref}
        className={cn(
          "bg-card rounded-2xl card-shadow",
          hoverable && "transition-all duration-200 hover:card-shadow-hover hover:-translate-y-0.5 cursor-pointer",
          className
        )}
        {...props}
      >
        {children}
      </motion.div>
    );
  }
);

KCard.displayName = "KCard";
